import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../../react-cognito";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../../components/loader";
import { createFormula } from "../../../actions/addTreatments";
import { forceInputUppercase } from "../../../utils/helper";

const $ = window.$;
const initialState = {
    currentFormNotValid: false,
    treatmentName: "",
    calculationType: "Tablet",
    strengthMg: "",
    doseMg: "",
    doseTimes: "",
    doseType: "Lb",
    minDuration: "",
    maxDuration: "",
    loading: false,
    doseLb: ""
  };
  let formdata = {};
  class NewTabletFormula extends React.Component {
    constructor(props) {
      super(props);
    }
  
    state = initialState;
  
    changeVal = event => {
      let excludes = [
        "strengthMg",
        "calculationType",
        "doseMg",
        "doseLb",
        "minDuration",
        "maxDuration",
        "doseType",
        "doseTimes"
      ];
      if (!excludes.includes(event.target.name)) forceInputUppercase(event);
      const value = event.target.value;
      this.setState({
        ...this.state,
        [event.target.name]: value
      });
    };
  
    resetState = () => {
      this.setState(initialState);
    };
  
    closeModal = () => {
      $("#new_tablet").modal("hide");
      this.resetState();
    };
  
    submitCal = event => {
      event.preventDefault();
      this.setState({ loading: true });
      if (this.validateForm()) {
        let data = Object.values(formdata).map(key => {
          if (key !== null) {
            return true;
          } else {
            return false;
          }
        });

        if (!data.includes(false)) {
          this.props.createFormula(formdata);
        } else {
          this.setState({ currentFormNotValid: true });
          this.setState({ loading: false });
          NotificationManager.warning("Please check input details again.");
        }
      }
    };
    validateForm() {
      const data = {
        PetShopId: this.props.petShop.currentPetshop.id,
        treatmentName:
          this.state.treatmentName.trim().length > 0
            ? this.state.treatmentName
            : null,
        calculationType: this.state.calculationType,
        strengthMg:
          this.state.strengthMg.toString().trim().length > 0
            ? this.state.strengthMg
            : null,
        doseMg:
          this.state.doseMg.toString().trim().length > 0
            ? this.state.doseMg
            : null,
        doseLb:
          this.state.doseLb.toString().trim().length > 0
            ? this.state.doseLb
            : null,
        doseTimes:
          this.state.doseTimes.toString().trim().length > 0
            ? this.state.doseTimes
            : null,
        doseType: this.state.doseType,
        minDuration:
          this.state.minDuration.toString().trim().length > 0
            ? this.state.minDuration
            : null,
        maxDuration:
          this.state.maxDuration.toString().trim().length > 0
            ? this.state.maxDuration
            : null
      };
      formdata = Object.assign({}, data);
      return true;
    }
    componentWillReceiveProps = nextProps => {
      if (this.props.setCalculations !== nextProps.setCalculations) {
        this.resetState();
        this.setState({ loading: false });
        this.closeModal();
      }
      if (this.props.setCalculationsError !== nextProps.setCalculationsError) {
        this.resetState();
        this.setState({ loading: false });
        this.closeModal();
        NotificationManager.error("Failed to add calculator");
      }
    };
  
    render() {
      const {
        treatmentName,
        strengthMg,
        doseMg,
        doseLb,
        doseTimes,
        doseType,
        minDuration,
        maxDuration
      } = this.state;
  
      return (
        <div
          className="modal fade show"
          id="new_tablet"
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <form onSubmit={this.submitCal} className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    New Tablet Dosage Calculator
                    <br />
                    <small>Use Formula - Please enter all values below</small>
                  </h5>
                  <button
                    type="button"
                    className="close"
                    onClick={this.closeModal}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="form-group m-form__group row">
                        <label className="col-lg-4 col-form-label">
                          Medication Name (eg: metronidazole tablet for dogs):
                        </label>
                        <div className="col-lg-8">
                          <input
                            type="text"
                            name="treatmentName"
                            value={treatmentName}
                            onChange={this.changeVal}
                            className="form-control m-input"
                            placeholder=""
                          />
                          <span
                            className={
                              formdata.treatmentName === null &&
                              this.state.currentFormNotValid
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter medication name
                          </span>
                        </div>
                      </div>
                      <div className="m-form__seperator m-form__seperator--dashed my-3"></div>
  
                      <div className="form-group m-form__group row">
                        <label className="col-lg-4 col-form-label">
                          Strength of medication (eg. 250mg per tablet):
                        </label>
                        <div className="col-12 col-lg-8 ">
                          <div className="input-group">
                            <input
                              type="number"
                              name="strengthMg"
                              value={strengthMg}
                              onChange={this.changeVal}
                              className="form-control m-input"
                              placeholder=""
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">mg per tab</span>
                            </div>
                          </div>
                          <span
                            className={
                              formdata.strengthMg === null &&
                              this.state.currentFormNotValid
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter strength (mg per tab)
                          </span>
                        </div>
                      </div>
                      <div className="form-group m-form__group row">
                        <div className="col-8">
                          <div className="m-radio-inline">
                            <label className="m-radio m-radio--solid m-radio--state-success">
                              <input
                                type="radio"
                                name="doseType"
                                checked={doseType === "Lb"}
                                onChange={this.changeVal}
                                value="Lb"
                              />{" "}
                              Lb
                              <span></span>
                            </label>
                            <label className="m-radio m-radio--solid m-radio--state-success">
                              <input
                                type="radio"
                                name="doseType"
                                checked={doseType === "Kg"}
                                onChange={this.changeVal}
                                value="Kg"
                              />{" "}
                              Kg
                              <span></span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group m-form__group row">
                        <label className="col-lg-4 col-form-label">
                          Vet recommended dose for animal (eg. 10mg per{" "}
                          {doseType === "Lb" ? "lb" : "kg"}):
                        </label>
                        <div className="col-6 col-lg-4 input_span">
                          <div className=" input-group">
                            <input
                              type="number"
                              name="doseMg"
                              value={doseMg}
                              onChange={this.changeVal}
                              className="form-control m-input"
                              placeholder=""
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">mg</span>
                            </div>
                          </div>
  
                          <span
                            className={
                              formdata.doseMg === null &&
                              this.state.currentFormNotValid
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter dose (mg)
                          </span>
                        </div>
                        <div className="col-6 col-lg-4 input_span ">
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">per</span>
                            </div>
                            <input
                              type="number"
                              name="doseLb"
                              value={doseLb}
                              onChange={this.changeVal}
                              className="form-control m-input"
                              placeholder=""
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">
                                {doseType === "Lb" ? "lb" : "kg"}
                              </span>
                            </div>
                          </div>
  
                          <span
                            className={
                              formdata.doseLb === null &&
                              this.state.currentFormNotValid
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter dose ({doseType === "Lb" ? "lb" : "kg"})
                          </span>
                        </div>
                      </div>
                      <div className="form-group m-form__group row">
                        <label className="col-lg-4 col-form-label">
                          How many times a day? (eg: 2x a day):
                        </label>
                        <div className="col-12 col-lg-8">
                          <div className="input-group">
                            <input
                              type="number"
                              name="doseTimes"
                              value={doseTimes}
                              onChange={this.changeVal}
                              className="form-control m-input"
                              placeholder=""
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">times per day</span>
                            </div>
                          </div>
                          <span
                            className={
                              formdata.doseTimes === null &&
                              this.state.currentFormNotValid
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter dose (x a day)
                          </span>
                        </div>
                      </div>
                      <div className="form-group m-form__group row">
                        <label className="col-lg-4 col-form-label">
                          Recommended Duration(eg: 5 days min. 10 days max.):
                        </label>
                        <div className="col-6 col-lg-4 input_span ">
                          <div className="input-group">
                            <input
                              type="number"
                              name="minDuration"
                              value={minDuration}
                              onChange={this.changeVal}
                              className="form-control m-input"
                              placeholder=""
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">days min.</span>
                            </div>
                          </div>
                          <span
                            className={
                              formdata.minDuration === null &&
                              this.state.currentFormNotValid
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter minimum duration (days)
                          </span>
                        </div>
  
                        <div className="col-6 col-lg-4 input_span ">
                          <div className="input-group">
                            <input
                              type="number"
                              name="maxDuration"
                              value={maxDuration}
                              onChange={this.changeVal}
                              className="form-control m-input"
                              placeholder=""
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">days max.</span>
                            </div>
                          </div>
                          <span
                            className={
                              formdata.maxDuration === null &&
                              this.state.currentFormNotValid
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter maximum duration (days)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div className="modal-footer">
                  {this.state.loading == false ? (
                    <div>
                      <button
                        type="button"
                        className="btn btn-secondary m-btn--pill mx-2"
                        onClick={this.closeModal}
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary m-btn--pill"
                      >
                        Submit
                      </button>
                    </div>
                  ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    }
  }
  
  const mapStateToProps = state => ({
    user: state.cognito.user,
    petShop: state.petShopReducer,
    setCalculations: state.addFormulaReducer.setCalculations,
    setCalculationsError: state.addFormulaReducer.setCalculationsError,
    error: state.addFormulaReducer.error
  });
  
  const mapDispatchToProps = dispatch => ({
    createFormula: attrs => {
      dispatch(createFormula(attrs)).catch(error => {
        NotificationManager.error("Something went wrong");
      });
    }
  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(NewTabletFormula)
  );